import { Component, OnInit } from '@angular/core';
import { Navigation, Router } from '@angular/router';
import { Personality } from 'src/app/@core/constants';
import { OnbaseProcedureResponseModel } from 'src/app/models/response/onbaseProcedureResponseModel';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';

@Component({
  selector: 'app-create-credit-request',
  templateUrl: './create-credit-request.component.html',
  styleUrls: ['./create-credit-request.component.sass']
})
export class CreateCreditRequestComponent implements OnInit {

  creditPlan: OnbaseProcedureResponseModel = new OnbaseProcedureResponseModel();
  constructor(private router: Router, private readonly exceptionSolutionService: ExceptionSolutionService) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state == undefined) {
      this.router.navigate(['creditRequests']);
      return;
    }
    let personality = navigation?.extras.state.customer.mainPersonalInfo.personality;
    this.creditPlan = navigation?.extras.state.creditPlan;
    if (personality == Personality.PERSON) {
      this.validateSendPersonPlans(navigation);

    }
    else if (navigation?.extras.state.customer.mainPersonalInfo.personality == Personality.LEGAL_ENTITY) {
      this.validateSendLegalEntityPlans(navigation);
    }

  }
  validateSendPersonPlans(navigation: Navigation) {
    switch (navigation?.extras.state?.creditPlan.code) {
      case "0001":
        this.router.navigate(["creditRequests", "create", "fastTrackPerson"],
          {
            state: navigation?.extras.state
          });
        break;
      case "0002":
        //immediateProcedurePerson
        this.router.navigate(["creditRequests", "create", "immediateProcedurePerson"],
          {
            state: navigation?.extras.state
          });
        break;
      case "0003":
        //immediateProcedurePerson
        this.router.navigate(["creditRequests", "create", "nbaPlan"],
          {
            state: navigation?.extras.state
          });
        break;
      case "0004":
        //immediateProcedurePerson
        this.router.navigate(["creditRequests", "create", "guaranteedPerson"],
          {
            state: navigation?.extras.state
          });
        break;
      case "0005":
        //immediateProcedurePerson
        this.router.navigate(["creditRequests", "create", "normalPerson"],
          {
            state: navigation?.extras.state
          });
        break;
      case "0006":
        this.router.navigate(["creditRequests", "create", "creditAnalysisPerson"],
          {
            state: navigation?.extras.state
          });
        break;
      case "0007":
        this.router.navigate(["creditRequests", "create", "employeePerson"],
          {
            state: navigation?.extras.state
          });
        break;
      case "0008":
        this.router.navigate(["creditRequests", "create", "agreementPerson"],
          {
            state: navigation?.extras.state
          });
        break;
      case "0010":
        this.router.navigate(["creditRequests", "create", "franchisedEntityPlan"],
          {
            state: navigation?.extras.state
          })
        break;
      default:
        this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito`, `Plan de credito ${navigation?.extras.state?.creditPlan.code || ""} invalido. Contactar al equipo de soporte`, undefined, 'error');
        this.router.navigate(['customer'])
        break;
    }
  }

  validateSendLegalEntityPlans(navigation: any) {
    switch (navigation?.extras.state?.creditPlan.code) {
      case "0006":
        this.router.navigate(["creditRequests", "create", "creditAnalysisLegalEntity"],
          {
            state: navigation?.extras.state
          });
        break;
      case "0008":
        this.router.navigate(["creditRequests", "create", "agreementLegalEntity"],
          {
            state: navigation?.extras.state
          });
        break;
      case "0010":
        this.router.navigate(["creditRequests", "create", "legalEntityPlan"],
          {
            state: navigation?.extras.state
          })
        break;
      case "0009":
        this.router.navigate(["creditRequests", "create", "thirtyDaysLegalEntity"],
          {
            state: navigation?.extras.state
          })
        break;
      default:
        this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito`, `Plan de credito ${navigation?.extras.state?.creditPlan.code || ""} invalido. Contactar al equipo de soporte`, undefined, 'error');
        this.router.navigate(['customer'])
        break;
    }
  }
  ngOnInit(): void {
  }

}
